import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, styled, Typography } from '@mui/material';
// Components
import { AuthLayout, VerifyForm, useAuthContext } from '@components/auth';

const Wrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(5),
  minHeight: 'calc(100vh - 63px)',
  maxWidth: 480,
  margin: '0 auto',

  '& > *': {
    width: '100%',
  },
}));

const Verify = () => {
  const { isVerified } = useAuthContext();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (isVerified) {
      navigate('/');
    }
  }, [isVerified]);

  const logo = () => {
    if (import.meta.env.VITE_SITE === 'Paybilt') {
      return '/images/paybilt.png';
    } else {
      return '/images/payper.png';
    }
  };

  return (
    <AuthLayout>
      <Wrap>
        <div>
          <Box mb={3}>
            <img src={logo()} width={100} alt={import.meta.env.VITE_SITE} />
          </Box>

          <VerifyForm />

          <Typography py={3} variant="body2" color="textSecondary">
            {'© '}
            {new Date().getFullYear()} {import.meta.env.VITE_SITE} {'.'} Privacy
            & Terms
          </Typography>
        </div>
      </Wrap>
    </AuthLayout>
  );
};

export default Verify;
